import { metrics } from '@seek/metrics-js';
import { Button, Inline } from 'braid-design-system';
import React from 'react';

import { Link } from 'src/components/Router/Link';
import type { AnalyticsCurrentPageSectionState } from 'src/modules/analytics/types';
import type { Mode, Card } from 'src/types';

interface Props {
  actionText: string;
  to: Card;
  mode: Mode;
  analytics: {
    currentPageSectionState: AnalyticsCurrentPageSectionState;
  };
  data: Record<string, string>;
  isEmpty?: boolean;
  onClick?: () => void;
}

export const CardAction = ({
  actionText,
  to,
  mode,
  analytics,
  isEmpty,
  onClick: onClickFn = () => {},
  ...restProps
}: Props) => {
  const onClick = () => {
    onClickFn();
    if (isEmpty) {
      metrics.count('click-empty-card-add-btn', [`card:${to}`]);
    }
  };
  return (
    <Inline space="none">
      <Link
        {...restProps}
        to={to}
        onClick={onClick}
        mode={mode}
        component={Button}
        tone="formAccent"
        variant="ghost"
        analytics={analytics}
      >
        {actionText}
      </Link>
    </Inline>
  );
};
